import React, { useContext } from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'
import useData from '../../hooks/useData'
import ElectionContext from '../../context/ElectionContext'
import LegislatureResults from './LegislatureResults'
import { API_ENDPOINT } from '../../config'
import { MN_HOUSE_DISTRICT_PATTERN } from '../../util'
import usePreviousElection from '../../hooks/usePreviousElection'

const MnHouse = () => {
  const context = useContext(ElectionContext)
  const { slug } = useParams()
  const previousElection = usePreviousElection(
    context,
    'legislature',
    'mn_house_races'
  )
  let isSlugGood = MN_HOUSE_DISTRICT_PATTERN.test(slug)
  let url = `${API_ENDPOINT}/${context.date}/mn_house_races`

  const data = useData(url, 30000)

  // The API has no per-district endpoint, so when the URL targets a single
  // district (e.g. /mn/house/4a) we fetch the full list and filter to that
  // district. Race districts look like "District 4A" (uppercase code).
  const filteredData =
    isSlugGood && data && typeof data !== 'string'
      ? {
          ...data,
          mnHouse: (data.mnHouse || []).filter(
            (race) => race.district === `District ${slug.toUpperCase()}`
          ),
        }
      : data

  return (
    <div className="Legislature">
      <Helmet>
        <title>MPR News | Live Results for MN House</title>
        <meta
          name="twitter:title"
          content="LIVE Election Results from MPR News | MN House"
        />
        <meta
          property="og:title"
          content="LIVE Election Results from MPR News | MN House"
        />
      </Helmet>
      <div className="section_header">
        <h2 className="hdg hdg-2 mobileCentered">Minnesota House</h2>
      </div>
      <LegislatureResults
        data={filteredData}
        mapTag="mnHouse"
        url={url}
        name="Minnesota House"
        previousElection={previousElection}
      />
    </div>
  )
}

export default MnHouse
